(function () {
// https://cookieconsent.orestbida.com
//import * as CookieConsent from 'vanilla-cookieconsent';
/*!
* CookieConsent 3.1.0
* https://github.com/orestbida/cookieconsent
* Author Orest Bida
* Released under the MIT License
*/ const $f91994d6acc8623b$var$e = 'opt-in', $f91994d6acc8623b$var$t = 'opt-out', $f91994d6acc8623b$var$o = 'show--consent', $f91994d6acc8623b$var$n = 'show--preferences', $f91994d6acc8623b$var$a = 'disable--interaction', $f91994d6acc8623b$var$s = 'data-category', $f91994d6acc8623b$var$c = 'div', $f91994d6acc8623b$var$r = 'button', $f91994d6acc8623b$var$i = 'aria-hidden', $f91994d6acc8623b$var$l = 'btn-group', $f91994d6acc8623b$var$d = 'click', $f91994d6acc8623b$var$f = 'data-role', $f91994d6acc8623b$var$_ = 'consentModal', $f91994d6acc8623b$var$u = 'preferencesModal';
class $f91994d6acc8623b$var$p {
    constructor(){
        this.t = {
            mode: $f91994d6acc8623b$var$e,
            revision: 0,
            autoShow: !0,
            lazyHtmlGeneration: !0,
            autoClearCookies: !0,
            manageScriptTags: !0,
            hideFromBots: !0,
            cookie: {
                name: 'cc_cookie',
                expiresAfterDays: 182,
                domain: '',
                path: '/',
                secure: !0,
                sameSite: 'Lax'
            }
        }, this.o = {
            i: {},
            l: '',
            _: {},
            u: {},
            p: {},
            m: [],
            v: !1,
            h: null,
            C: null,
            S: null,
            M: '',
            D: !0,
            T: !1,
            k: !1,
            A: !1,
            N: !1,
            H: [],
            V: !1,
            I: !0,
            L: [],
            j: !1,
            F: '',
            P: !1,
            O: [],
            R: [],
            B: [],
            $: [],
            G: !1,
            J: !1,
            U: !1,
            q: [],
            K: [],
            W: [],
            X: {},
            Y: {},
            Z: {},
            ee: {},
            te: {},
            oe: []
        }, this.ne = {
            ae: {},
            se: {}
        }, this.ce = {}, this.re = {
            ie: 'cc:onFirstConsent',
            le: 'cc:onConsent',
            de: 'cc:onChange',
            fe: 'cc:onModalShow',
            _e: 'cc:onModalHide',
            ue: 'cc:onModalReady'
        };
    }
}
const $f91994d6acc8623b$var$g = new $f91994d6acc8623b$var$p, $f91994d6acc8623b$var$m = (e, t)=>e.indexOf(t), $f91994d6acc8623b$var$b = (e, t)=>-1 !== $f91994d6acc8623b$var$m(e, t), $f91994d6acc8623b$var$v = (e)=>Array.isArray(e), $f91994d6acc8623b$var$y = (e)=>'string' == typeof e, $f91994d6acc8623b$var$h = (e)=>!!e && 'object' == typeof e && !$f91994d6acc8623b$var$v(e), $f91994d6acc8623b$var$C = (e)=>'function' == typeof e, $f91994d6acc8623b$var$w = (e)=>Object.keys(e), $f91994d6acc8623b$var$S = (e)=>Array.from(new Set(e)), $f91994d6acc8623b$var$x = ()=>document.activeElement, $f91994d6acc8623b$var$M = (e)=>e.preventDefault(), $f91994d6acc8623b$var$D = (e, t)=>e.querySelectorAll(t), $f91994d6acc8623b$var$T = (e)=>e.dispatchEvent(new Event('change')), $f91994d6acc8623b$var$k = (e)=>{
    const t = document.createElement(e);
    return e === $f91994d6acc8623b$var$r && (t.type = e), t;
}, $f91994d6acc8623b$var$E = (e, t, o)=>e.setAttribute(t, o), $f91994d6acc8623b$var$A = (e, t, o)=>{
    e.removeAttribute(o ? 'data-' + t : t);
}, $f91994d6acc8623b$var$N = (e, t, o)=>e.getAttribute(o ? 'data-' + t : t), $f91994d6acc8623b$var$H = (e, t)=>e.appendChild(t), $f91994d6acc8623b$var$V = (e, t)=>e.classList.add(t), $f91994d6acc8623b$var$I = (e, t)=>$f91994d6acc8623b$var$V(e, 'cm__' + t), $f91994d6acc8623b$var$L = (e, t)=>$f91994d6acc8623b$var$V(e, 'pm__' + t), $f91994d6acc8623b$var$j = (e, t)=>e.classList.remove(t), $f91994d6acc8623b$var$F = (e)=>{
    if ('object' != typeof e) return e;
    if (e instanceof Date) return new Date(e.getTime());
    let t = Array.isArray(e) ? [] : {};
    for(let o in e){
        let n = e[o];
        t[o] = $f91994d6acc8623b$var$F(n);
    }
    return t;
}, $f91994d6acc8623b$var$P = ()=>{
    const e = {}, { O: t, X: o, Y: n } = $f91994d6acc8623b$var$g.o;
    for (const a of t)e[a] = $f91994d6acc8623b$var$$(n[a], $f91994d6acc8623b$var$w(o[a]));
    return e;
}, $f91994d6acc8623b$var$O = (e, t)=>dispatchEvent(new CustomEvent(e, {
        detail: t
    })), $f91994d6acc8623b$var$R = (e, t, o, n)=>{
    e.addEventListener(t, o), n && $f91994d6acc8623b$var$g.o.m.push({
        pe: e,
        ge: t,
        me: o
    });
}, $f91994d6acc8623b$var$B = ()=>{
    const e = $f91994d6acc8623b$var$g.t.cookie.expiresAfterDays;
    return $f91994d6acc8623b$var$C(e) ? e($f91994d6acc8623b$var$g.o.F) : e;
}, $f91994d6acc8623b$var$$ = (e, t)=>{
    const o = e || [], n = t || [];
    return o.filter((e)=>!$f91994d6acc8623b$var$b(n, e)).concat(n.filter((e)=>!$f91994d6acc8623b$var$b(o, e)));
}, $f91994d6acc8623b$var$G = (e)=>{
    $f91994d6acc8623b$var$g.o.R = $f91994d6acc8623b$var$S(e), $f91994d6acc8623b$var$g.o.F = (()=>{
        let e = 'custom';
        const { R: t, O: o, B: n } = $f91994d6acc8623b$var$g.o, a = t.length;
        return a === o.length ? e = 'all' : a === n.length && (e = 'necessary'), e;
    })();
}, $f91994d6acc8623b$var$J = (e, t, o, n)=>{
    const a = 'accept-', { show: s, showPreferences: c, hide: r, hidePreferences: i, acceptCategory: l } = t, f = e || document, _ = (e)=>$f91994d6acc8623b$var$D(f, `[data-cc="${e}"]`), u = (e, t)=>{
        $f91994d6acc8623b$var$M(e), l(t), i(), r();
    }, p = _('show-preferencesModal'), m = _('show-consentModal'), b = _(a + 'all'), v = _(a + 'necessary'), y = _(a + 'custom'), h = $f91994d6acc8623b$var$g.t.lazyHtmlGeneration;
    for (const e of p)$f91994d6acc8623b$var$E(e, 'aria-haspopup', 'dialog'), $f91994d6acc8623b$var$R(e, $f91994d6acc8623b$var$d, (e)=>{
        $f91994d6acc8623b$var$M(e), c();
    }), h && ($f91994d6acc8623b$var$R(e, 'mouseenter', (e)=>{
        $f91994d6acc8623b$var$M(e), $f91994d6acc8623b$var$g.o.N || o(t, n);
    }, !0), $f91994d6acc8623b$var$R(e, 'focus', ()=>{
        $f91994d6acc8623b$var$g.o.N || o(t, n);
    }));
    for (let e of m)$f91994d6acc8623b$var$E(e, 'aria-haspopup', 'dialog'), $f91994d6acc8623b$var$R(e, $f91994d6acc8623b$var$d, (e)=>{
        $f91994d6acc8623b$var$M(e), s(!0);
    }, !0);
    for (let e of b)$f91994d6acc8623b$var$R(e, $f91994d6acc8623b$var$d, (e)=>{
        u(e, 'all');
    }, !0);
    for (let e of y)$f91994d6acc8623b$var$R(e, $f91994d6acc8623b$var$d, (e)=>{
        u(e);
    }, !0);
    for (let e of v)$f91994d6acc8623b$var$R(e, $f91994d6acc8623b$var$d, (e)=>{
        u(e, []);
    }, !0);
}, $f91994d6acc8623b$var$U = (e, t)=>{
    e && (t && (e.tabIndex = -1), e.focus(), t && e.removeAttribute('tabindex'));
}, $f91994d6acc8623b$var$z = (e, t)=>{
    const o = (n)=>{
        n.target.removeEventListener('transitionend', o), 'opacity' === n.propertyName && '1' === getComputedStyle(e).opacity && $f91994d6acc8623b$var$U(((e)=>1 === e ? $f91994d6acc8623b$var$g.ne.be : $f91994d6acc8623b$var$g.ne.ve)(t));
    };
    $f91994d6acc8623b$var$R(e, 'transitionend', o);
};
let $f91994d6acc8623b$var$q;
const $f91994d6acc8623b$var$K = (e)=>{
    clearTimeout($f91994d6acc8623b$var$q), e ? $f91994d6acc8623b$var$V($f91994d6acc8623b$var$g.ne.ye, $f91994d6acc8623b$var$a) : $f91994d6acc8623b$var$q = setTimeout(()=>{
        $f91994d6acc8623b$var$j($f91994d6acc8623b$var$g.ne.ye, $f91994d6acc8623b$var$a);
    }, 500);
}, $f91994d6acc8623b$var$Q = [
    'M 19.5 4.5 L 4.5 19.5 M 4.5 4.501 L 19.5 19.5',
    'M 3.572 13.406 L 8.281 18.115 L 20.428 5.885',
    'M 21.999 6.94 L 11.639 17.18 L 2.001 6.82 '
], $f91994d6acc8623b$var$W = (e = 0, t = 1.5)=>`<svg viewBox="0 0 24 24" stroke-width="${t}"><path d="${$f91994d6acc8623b$var$Q[e]}"/></svg>`, $f91994d6acc8623b$var$X = (e)=>{
    const t = $f91994d6acc8623b$var$g.ne, o = $f91994d6acc8623b$var$g.o;
    ((e)=>{
        const n = e === t.he, a = o.i.disablePageInteraction ? t.ye : n ? t.Ce : t.ye;
        $f91994d6acc8623b$var$R(a, 'keydown', (t)=>{
            if ('Tab' !== t.key || !(n ? o.k && !o.A : o.A)) return;
            const a = $f91994d6acc8623b$var$x(), s = n ? o.q : o.K;
            0 !== s.length && (t.shiftKey ? a !== s[0] && e.contains(a) || ($f91994d6acc8623b$var$M(t), $f91994d6acc8623b$var$U(s[1])) : a !== s[1] && e.contains(a) || ($f91994d6acc8623b$var$M(t), $f91994d6acc8623b$var$U(s[0])));
        }, !0);
    })(e);
}, $f91994d6acc8623b$var$Y = [
    '[href]',
    $f91994d6acc8623b$var$r,
    'input',
    'details',
    '[tabindex]'
].map((e)=>e + ':not([tabindex="-1"])').join(','), $f91994d6acc8623b$var$Z = (e)=>{
    const { o: t, ne: o } = $f91994d6acc8623b$var$g, n = (e, t)=>{
        const o = $f91994d6acc8623b$var$D(e, $f91994d6acc8623b$var$Y);
        t[0] = o[0], t[1] = o[o.length - 1];
    };
    1 === e && t.T && n(o.he, t.q), 2 === e && t.N && n(o.we, t.K);
}, $f91994d6acc8623b$var$ee = (e, t, o)=>{
    const { de: n, le: a, ie: s, _e: c, ue: r, fe: i } = $f91994d6acc8623b$var$g.ce, l = $f91994d6acc8623b$var$g.re;
    if (t) {
        const n = {
            modalName: t
        };
        return e === l.fe ? $f91994d6acc8623b$var$C(i) && i(n) : e === l._e ? $f91994d6acc8623b$var$C(c) && c(n) : (n.modal = o, $f91994d6acc8623b$var$C(r) && r(n)), $f91994d6acc8623b$var$O(e, n);
    }
    const d = {
        cookie: $f91994d6acc8623b$var$g.o.p
    };
    e === l.ie ? $f91994d6acc8623b$var$C(s) && s($f91994d6acc8623b$var$F(d)) : e === l.le ? $f91994d6acc8623b$var$C(a) && a($f91994d6acc8623b$var$F(d)) : (d.changedCategories = $f91994d6acc8623b$var$g.o.L, d.changedServices = $f91994d6acc8623b$var$g.o.ee, $f91994d6acc8623b$var$C(n) && n($f91994d6acc8623b$var$F(d))), $f91994d6acc8623b$var$O(e, $f91994d6acc8623b$var$F(d));
}, $f91994d6acc8623b$var$te = (e, t)=>{
    try {
        return e();
    } catch (e) {
        return !t && console.warn('CookieConsent:', e), !1;
    }
}, $f91994d6acc8623b$var$oe = (e)=>{
    const { Y: t, ee: o, O: n, X: a, oe: c, p: r, L: i } = $f91994d6acc8623b$var$g.o;
    for (const e of n){
        const n = o[e] || t[e] || [];
        for (const o of n){
            const n = a[e][o];
            if (!n) continue;
            const { onAccept: s, onReject: c } = n;
            !n.Se && $f91994d6acc8623b$var$b(t[e], o) ? (n.Se = !0, $f91994d6acc8623b$var$C(s) && s()) : n.Se && !$f91994d6acc8623b$var$b(t[e], o) && (n.Se = !1, $f91994d6acc8623b$var$C(c) && c());
        }
    }
    if (!$f91994d6acc8623b$var$g.t.manageScriptTags) return;
    const l = c, d = e || r.categories || [], f = (e, n)=>{
        if (n >= e.length) return;
        const a = c[n];
        if (a.xe) return f(e, n + 1);
        const r = a.Me, l = a.De, _ = a.Te, u = $f91994d6acc8623b$var$b(d, l), p = !!_ && $f91994d6acc8623b$var$b(t[l], _);
        if (!_ && !a.ke && u || !_ && a.ke && !u && $f91994d6acc8623b$var$b(i, l) || _ && !a.ke && p || _ && a.ke && !p && $f91994d6acc8623b$var$b(o[l] || [], _)) {
            a.xe = !0;
            const t = $f91994d6acc8623b$var$N(r, 'type', !0);
            $f91994d6acc8623b$var$A(r, 'type', !!t), $f91994d6acc8623b$var$A(r, $f91994d6acc8623b$var$s);
            let o = $f91994d6acc8623b$var$N(r, 'src', !0);
            o && $f91994d6acc8623b$var$A(r, 'src', !0);
            const c = $f91994d6acc8623b$var$k('script');
            c.textContent = r.innerHTML;
            for (const { nodeName: e } of r.attributes)$f91994d6acc8623b$var$E(c, e, r[e] || $f91994d6acc8623b$var$N(r, e));
            t && (c.type = t), o ? c.src = o : o = r.src;
            const i = !!o && (!t || [
                'text/javascript',
                'module'
            ].includes(t));
            if (i && (c.onload = c.onerror = ()=>{
                f(e, ++n);
            }), r.replaceWith(c), i) return;
        }
        f(e, ++n);
    };
    f(l, 0);
}, $f91994d6acc8623b$var$ne = 'bottom', $f91994d6acc8623b$var$ae = 'left', $f91994d6acc8623b$var$se = 'center', $f91994d6acc8623b$var$ce = 'right', $f91994d6acc8623b$var$re = 'inline', $f91994d6acc8623b$var$ie = 'wide', $f91994d6acc8623b$var$le = 'pm--', $f91994d6acc8623b$var$de = [
    'middle',
    'top',
    $f91994d6acc8623b$var$ne
], $f91994d6acc8623b$var$fe = [
    $f91994d6acc8623b$var$ae,
    $f91994d6acc8623b$var$se,
    $f91994d6acc8623b$var$ce
], $f91994d6acc8623b$var$_e = {
    box: {
        Ee: [
            $f91994d6acc8623b$var$ie,
            $f91994d6acc8623b$var$re
        ],
        Ae: $f91994d6acc8623b$var$de,
        Ne: $f91994d6acc8623b$var$fe,
        He: $f91994d6acc8623b$var$ne,
        Ve: $f91994d6acc8623b$var$ce
    },
    cloud: {
        Ee: [
            $f91994d6acc8623b$var$re
        ],
        Ae: $f91994d6acc8623b$var$de,
        Ne: $f91994d6acc8623b$var$fe,
        He: $f91994d6acc8623b$var$ne,
        Ve: $f91994d6acc8623b$var$se
    },
    bar: {
        Ee: [
            $f91994d6acc8623b$var$re
        ],
        Ae: $f91994d6acc8623b$var$de.slice(1),
        Ne: [],
        He: $f91994d6acc8623b$var$ne,
        Ve: ''
    }
}, $f91994d6acc8623b$var$ue = {
    box: {
        Ee: [],
        Ae: [],
        Ne: [],
        He: '',
        Ve: ''
    },
    bar: {
        Ee: [
            $f91994d6acc8623b$var$ie
        ],
        Ae: [],
        Ne: [
            $f91994d6acc8623b$var$ae,
            $f91994d6acc8623b$var$ce
        ],
        He: '',
        Ve: $f91994d6acc8623b$var$ae
    }
}, $f91994d6acc8623b$var$pe = (e)=>{
    const t = $f91994d6acc8623b$var$g.o.i.guiOptions, o = t && t.consentModal, n = t && t.preferencesModal;
    0 === e && $f91994d6acc8623b$var$ge($f91994d6acc8623b$var$g.ne.he, $f91994d6acc8623b$var$_e, o, 'cm--', 'box', 'cm'), 1 === e && $f91994d6acc8623b$var$ge($f91994d6acc8623b$var$g.ne.we, $f91994d6acc8623b$var$ue, n, $f91994d6acc8623b$var$le, 'box', 'pm');
}, $f91994d6acc8623b$var$ge = (e, t, o, n, a, s)=>{
    e.className = s;
    const c = o && o.layout, r = o && o.position, i = o && o.flipButtons, l = !o || !1 !== o.equalWeightButtons, d = c && c.split(' ') || [], f = d[0], _ = d[1], u = f in t ? f : a, p = t[u], m = $f91994d6acc8623b$var$b(p.Ee, _) && _, v = r && r.split(' ') || [], y = v[0], h = n === $f91994d6acc8623b$var$le ? v[0] : v[1], C = $f91994d6acc8623b$var$b(p.Ae, y) ? y : p.He, w = $f91994d6acc8623b$var$b(p.Ne, h) ? h : p.Ve, S = (t)=>{
        t && $f91994d6acc8623b$var$V(e, n + t);
    };
    S(u), S(m), S(C), S(w), i && S('flip');
    const x = s + '__btn--secondary';
    if ('cm' === s) {
        const { Ie: e, Le: t } = $f91994d6acc8623b$var$g.ne;
        e && (l ? $f91994d6acc8623b$var$j(e, x) : $f91994d6acc8623b$var$V(e, x)), t && (l ? $f91994d6acc8623b$var$j(t, x) : $f91994d6acc8623b$var$V(t, x));
    } else {
        const { je: e } = $f91994d6acc8623b$var$g.ne;
        e && (l ? $f91994d6acc8623b$var$j(e, x) : $f91994d6acc8623b$var$V(e, x));
    }
}, $f91994d6acc8623b$var$me = (e, t)=>{
    const o = $f91994d6acc8623b$var$g.o, n = $f91994d6acc8623b$var$g.ne, { hide: a, hidePreferences: s, acceptCategory: _ } = e, p = (e)=>{
        _(e), s(), a();
    }, m = o.u && o.u.preferencesModal;
    if (!m) return;
    const b = m.title, v = m.closeIconLabel, C = m.acceptAllBtn, S = m.acceptNecessaryBtn, x = m.savePreferencesBtn, M = m.sections || [], D = C || S || x;
    if (n.Fe) n.Pe = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$c), $f91994d6acc8623b$var$L(n.Pe, 'body');
    else {
        n.Fe = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$c), $f91994d6acc8623b$var$V(n.Fe, 'pm-wrapper');
        const e = $f91994d6acc8623b$var$k('div');
        $f91994d6acc8623b$var$V(e, 'pm-overlay'), $f91994d6acc8623b$var$H(n.Fe, e), $f91994d6acc8623b$var$R(e, $f91994d6acc8623b$var$d, s), n.we = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$c), $f91994d6acc8623b$var$V(n.we, 'pm'), $f91994d6acc8623b$var$E(n.we, 'role', 'dialog'), $f91994d6acc8623b$var$E(n.we, $f91994d6acc8623b$var$i, !0), $f91994d6acc8623b$var$E(n.we, 'aria-modal', !0), $f91994d6acc8623b$var$E(n.we, 'aria-labelledby', 'pm__title'), $f91994d6acc8623b$var$R(n.ye, 'keydown', (e)=>{
            27 === e.keyCode && s();
        }, !0), n.Oe = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$c), $f91994d6acc8623b$var$L(n.Oe, 'header'), n.Re = $f91994d6acc8623b$var$k('h2'), $f91994d6acc8623b$var$L(n.Re, 'title'), n.Re.id = 'pm__title', n.Be = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$r), $f91994d6acc8623b$var$L(n.Be, 'close-btn'), $f91994d6acc8623b$var$E(n.Be, 'aria-label', m.closeIconLabel || ''), $f91994d6acc8623b$var$R(n.Be, $f91994d6acc8623b$var$d, s), n.$e = $f91994d6acc8623b$var$k('span'), n.$e.innerHTML = $f91994d6acc8623b$var$W(), $f91994d6acc8623b$var$H(n.Be, n.$e), n.Ge = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$c), $f91994d6acc8623b$var$L(n.Ge, 'body'), n.Je = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$c), $f91994d6acc8623b$var$L(n.Je, 'footer');
        var T = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$c);
        $f91994d6acc8623b$var$V(T, 'btns');
        var A = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$c), N = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$c);
        $f91994d6acc8623b$var$L(A, $f91994d6acc8623b$var$l), $f91994d6acc8623b$var$L(N, $f91994d6acc8623b$var$l), $f91994d6acc8623b$var$H(n.Je, A), $f91994d6acc8623b$var$H(n.Je, N), $f91994d6acc8623b$var$H(n.Oe, n.Re), $f91994d6acc8623b$var$H(n.Oe, n.Be), n.ve = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$c), $f91994d6acc8623b$var$E(n.ve, 'tabIndex', -1), $f91994d6acc8623b$var$H(n.we, n.ve), $f91994d6acc8623b$var$H(n.we, n.Oe), $f91994d6acc8623b$var$H(n.we, n.Ge), D && $f91994d6acc8623b$var$H(n.we, n.Je), $f91994d6acc8623b$var$H(n.Fe, n.we);
    }
    let I;
    b && (n.Re.innerHTML = b, v && $f91994d6acc8623b$var$E(n.Be, 'aria-label', v)), M.forEach((e, t)=>{
        const a = e.title, s = e.description, l = e.linkedCategory, f = l && o.P[l], _ = e.cookieTable, u = _ && _.body, p = _ && _.caption, g = u && u.length > 0, b = !!f, v = b && o.X[l], C = $f91994d6acc8623b$var$h(v) && $f91994d6acc8623b$var$w(v) || [], S = b && (!!s || !!g || $f91994d6acc8623b$var$w(v).length > 0);
        var x = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$c);
        if ($f91994d6acc8623b$var$L(x, 'section'), S || s) {
            var M = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$c);
            $f91994d6acc8623b$var$L(M, 'section-desc-wrapper');
        }
        let D = C.length;
        if (S && D > 0) {
            const e = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$c);
            $f91994d6acc8623b$var$L(e, 'section-services');
            for (const t of C){
                const o = v[t], n = o && o.label || t, a = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$c), s = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$c), r = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$c), i = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$c);
                $f91994d6acc8623b$var$L(a, 'service'), $f91994d6acc8623b$var$L(i, 'service-title'), $f91994d6acc8623b$var$L(s, 'service-header'), $f91994d6acc8623b$var$L(r, 'service-icon');
                const d = $f91994d6acc8623b$var$be(n, t, f, !0, l);
                i.innerHTML = n, $f91994d6acc8623b$var$H(s, r), $f91994d6acc8623b$var$H(s, i), $f91994d6acc8623b$var$H(a, s), $f91994d6acc8623b$var$H(a, d), $f91994d6acc8623b$var$H(e, a);
            }
            $f91994d6acc8623b$var$H(M, e);
        }
        if (a) {
            var T = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$c), A = $f91994d6acc8623b$var$k(b ? $f91994d6acc8623b$var$r : $f91994d6acc8623b$var$c);
            if ($f91994d6acc8623b$var$L(T, 'section-title-wrapper'), $f91994d6acc8623b$var$L(A, 'section-title'), A.innerHTML = a, $f91994d6acc8623b$var$H(T, A), b) {
                const e = $f91994d6acc8623b$var$k('span');
                e.innerHTML = $f91994d6acc8623b$var$W(2, 3.5), $f91994d6acc8623b$var$L(e, 'section-arrow'), $f91994d6acc8623b$var$H(T, e), x.className += '--toggle';
                const t = $f91994d6acc8623b$var$be(a, l, f);
                let o = m.serviceCounterLabel;
                if (D > 0 && $f91994d6acc8623b$var$y(o)) {
                    let e = $f91994d6acc8623b$var$k('span');
                    $f91994d6acc8623b$var$L(e, 'badge'), $f91994d6acc8623b$var$L(e, 'service-counter'), $f91994d6acc8623b$var$E(e, $f91994d6acc8623b$var$i, !0), $f91994d6acc8623b$var$E(e, 'data-servicecounter', D), o && (o = o.split('|'), o = o.length > 1 && D > 1 ? o[1] : o[0], $f91994d6acc8623b$var$E(e, 'data-counterlabel', o)), e.innerHTML = D + (o ? ' ' + o : ''), $f91994d6acc8623b$var$H(A, e);
                }
                if (S) {
                    $f91994d6acc8623b$var$L(x, 'section--expandable');
                    var N = l + '-desc';
                    $f91994d6acc8623b$var$E(A, 'aria-expanded', !1), $f91994d6acc8623b$var$E(A, 'aria-controls', N);
                }
                $f91994d6acc8623b$var$H(T, t);
            } else $f91994d6acc8623b$var$E(A, 'role', 'heading'), $f91994d6acc8623b$var$E(A, 'aria-level', '3');
            $f91994d6acc8623b$var$H(x, T);
        }
        if (s) {
            var F = $f91994d6acc8623b$var$k('p');
            $f91994d6acc8623b$var$L(F, 'section-desc'), F.innerHTML = s, $f91994d6acc8623b$var$H(M, F);
        }
        if (S && ($f91994d6acc8623b$var$E(M, $f91994d6acc8623b$var$i, 'true'), M.id = N, ((e, t, o)=>{
            $f91994d6acc8623b$var$R(A, $f91994d6acc8623b$var$d, ()=>{
                t.classList.contains('is-expanded') ? ($f91994d6acc8623b$var$j(t, 'is-expanded'), $f91994d6acc8623b$var$E(o, 'aria-expanded', 'false'), $f91994d6acc8623b$var$E(e, $f91994d6acc8623b$var$i, 'true')) : ($f91994d6acc8623b$var$V(t, 'is-expanded'), $f91994d6acc8623b$var$E(o, 'aria-expanded', 'true'), $f91994d6acc8623b$var$E(e, $f91994d6acc8623b$var$i, 'false'));
            });
        })(M, x, A), g)) {
            const e = $f91994d6acc8623b$var$k('table'), o = $f91994d6acc8623b$var$k('thead'), a = $f91994d6acc8623b$var$k('tbody');
            if (p) {
                const t = $f91994d6acc8623b$var$k('caption');
                $f91994d6acc8623b$var$L(t, 'table-caption'), t.innerHTML = p, e.appendChild(t);
            }
            $f91994d6acc8623b$var$L(e, 'section-table'), $f91994d6acc8623b$var$L(o, 'table-head'), $f91994d6acc8623b$var$L(a, 'table-body');
            const s = _.headers, r = $f91994d6acc8623b$var$w(s), i = n.Ue.createDocumentFragment(), l = $f91994d6acc8623b$var$k('tr');
            for (const e of r){
                const o = s[e], n = $f91994d6acc8623b$var$k('th');
                n.id = 'cc__row-' + o + t, $f91994d6acc8623b$var$E(n, 'scope', 'col'), $f91994d6acc8623b$var$L(n, 'table-th'), n.innerHTML = o, $f91994d6acc8623b$var$H(i, n);
            }
            $f91994d6acc8623b$var$H(l, i), $f91994d6acc8623b$var$H(o, l);
            const d = n.Ue.createDocumentFragment();
            for (const e of u){
                const o = $f91994d6acc8623b$var$k('tr');
                $f91994d6acc8623b$var$L(o, 'table-tr');
                for (const n of r){
                    const a = s[n], r = e[n], i = $f91994d6acc8623b$var$k('td'), l = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$c);
                    $f91994d6acc8623b$var$L(i, 'table-td'), $f91994d6acc8623b$var$E(i, 'data-column', a), $f91994d6acc8623b$var$E(i, 'headers', 'cc__row-' + a + t), l.insertAdjacentHTML('beforeend', r), $f91994d6acc8623b$var$H(i, l), $f91994d6acc8623b$var$H(o, i);
                }
                $f91994d6acc8623b$var$H(d, o);
            }
            $f91994d6acc8623b$var$H(a, d), $f91994d6acc8623b$var$H(e, o), $f91994d6acc8623b$var$H(e, a), $f91994d6acc8623b$var$H(M, e);
        }
        (S || s) && $f91994d6acc8623b$var$H(x, M);
        const P = n.Pe || n.Ge;
        b ? (I || (I = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$c), $f91994d6acc8623b$var$L(I, 'section-toggles')), I.appendChild(x)) : I = null, $f91994d6acc8623b$var$H(P, I || x);
    }), C && (n.ze || (n.ze = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$r), $f91994d6acc8623b$var$L(n.ze, 'btn'), $f91994d6acc8623b$var$E(n.ze, $f91994d6acc8623b$var$f, 'all'), $f91994d6acc8623b$var$H(A, n.ze), $f91994d6acc8623b$var$R(n.ze, $f91994d6acc8623b$var$d, ()=>p('all'))), n.ze.innerHTML = C), S && (n.je || (n.je = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$r), $f91994d6acc8623b$var$L(n.je, 'btn'), $f91994d6acc8623b$var$E(n.je, $f91994d6acc8623b$var$f, 'necessary'), $f91994d6acc8623b$var$H(A, n.je), $f91994d6acc8623b$var$R(n.je, $f91994d6acc8623b$var$d, ()=>p([]))), n.je.innerHTML = S), x && (n.qe || (n.qe = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$r), $f91994d6acc8623b$var$L(n.qe, 'btn'), $f91994d6acc8623b$var$L(n.qe, 'btn--secondary'), $f91994d6acc8623b$var$E(n.qe, $f91994d6acc8623b$var$f, 'save'), $f91994d6acc8623b$var$H(N, n.qe), $f91994d6acc8623b$var$R(n.qe, $f91994d6acc8623b$var$d, ()=>p())), n.qe.innerHTML = x), n.Pe && (n.we.replaceChild(n.Pe, n.Ge), n.Ge = n.Pe), $f91994d6acc8623b$var$pe(1), o.N || (o.N = !0, $f91994d6acc8623b$var$ee($f91994d6acc8623b$var$g.re.ue, $f91994d6acc8623b$var$u, n.we), t(e), $f91994d6acc8623b$var$H(n.Ce, n.Fe), $f91994d6acc8623b$var$X(n.we), setTimeout(()=>$f91994d6acc8623b$var$V(n.Fe, 'cc--anim'), 100)), $f91994d6acc8623b$var$Z(2);
};
function $f91994d6acc8623b$var$be(e, t, o, n, a) {
    const c = $f91994d6acc8623b$var$g.o, r = $f91994d6acc8623b$var$g.ne, l = $f91994d6acc8623b$var$k('label'), f = $f91994d6acc8623b$var$k('input'), _ = $f91994d6acc8623b$var$k('span'), u = $f91994d6acc8623b$var$k('span'), p = $f91994d6acc8623b$var$k('span'), m = $f91994d6acc8623b$var$k('span'), v = $f91994d6acc8623b$var$k('span');
    if (m.innerHTML = $f91994d6acc8623b$var$W(1, 3), v.innerHTML = $f91994d6acc8623b$var$W(0, 3), f.type = 'checkbox', $f91994d6acc8623b$var$V(l, 'section__toggle-wrapper'), $f91994d6acc8623b$var$V(f, 'section__toggle'), $f91994d6acc8623b$var$V(m, 'toggle__icon-on'), $f91994d6acc8623b$var$V(v, 'toggle__icon-off'), $f91994d6acc8623b$var$V(_, 'toggle__icon'), $f91994d6acc8623b$var$V(u, 'toggle__icon-circle'), $f91994d6acc8623b$var$V(p, 'toggle__label'), $f91994d6acc8623b$var$E(_, $f91994d6acc8623b$var$i, 'true'), n ? ($f91994d6acc8623b$var$V(l, 'toggle-service'), $f91994d6acc8623b$var$E(f, $f91994d6acc8623b$var$s, a), r.se[a][t] = f) : r.ae[t] = f, n ? ((e)=>{
        $f91994d6acc8623b$var$R(f, 'change', ()=>{
            const t = r.se[e], o = r.ae[e];
            c.Z[e] = [];
            for(let o in t){
                const n = t[o];
                n.checked && c.Z[e].push(n.value);
            }
            o.checked = c.Z[e].length > 0;
        });
    })(a) : ((e)=>{
        $f91994d6acc8623b$var$R(f, $f91994d6acc8623b$var$d, ()=>{
            const t = r.se[e], o = f.checked;
            c.Z[e] = [];
            for(let n in t)t[n].checked = o, o && c.Z[e].push(n);
        });
    })(t), f.value = t, p.textContent = e.replace(/<.*>.*<\/.*>/gm, ''), $f91994d6acc8623b$var$H(u, v), $f91994d6acc8623b$var$H(u, m), $f91994d6acc8623b$var$H(_, u), c.D) (o.readOnly || o.enabled) && (f.checked = !0);
    else if (n) {
        const e = c.Y[a];
        f.checked = o.readOnly || $f91994d6acc8623b$var$b(e, t);
    } else $f91994d6acc8623b$var$b(c.R, t) && (f.checked = !0);
    return o.readOnly && (f.disabled = !0), $f91994d6acc8623b$var$H(l, f), $f91994d6acc8623b$var$H(l, _), $f91994d6acc8623b$var$H(l, p), l;
}
const $f91994d6acc8623b$var$ve = ()=>{
    const e = $f91994d6acc8623b$var$k('span');
    return $f91994d6acc8623b$var$g.ne.Ke || ($f91994d6acc8623b$var$g.ne.Ke = e), e;
}, $f91994d6acc8623b$var$ye = (e, t)=>{
    const o = $f91994d6acc8623b$var$g.o, n = $f91994d6acc8623b$var$g.ne, { hide: a, showPreferences: s, acceptCategory: u } = e, p = o.u && o.u.consentModal;
    if (!p) return;
    const m = p.acceptAllBtn, b = p.acceptNecessaryBtn, v = p.showPreferencesBtn, y = p.closeIconLabel, h = p.footer, C = p.label, w = p.title, S = (e)=>{
        a(), u(e);
    };
    if (!n.Qe) {
        n.Qe = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$c), n.he = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$c), n.We = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$c), n.Xe = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$c), n.Ye = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$c), $f91994d6acc8623b$var$V(n.Qe, 'cm-wrapper'), $f91994d6acc8623b$var$V(n.he, 'cm'), $f91994d6acc8623b$var$I(n.We, 'body'), $f91994d6acc8623b$var$I(n.Xe, 'texts'), $f91994d6acc8623b$var$I(n.Ye, 'btns'), $f91994d6acc8623b$var$E(n.he, 'role', 'dialog'), $f91994d6acc8623b$var$E(n.he, 'aria-modal', 'true'), $f91994d6acc8623b$var$E(n.he, $f91994d6acc8623b$var$i, 'false'), $f91994d6acc8623b$var$E(n.he, 'aria-describedby', 'cm__desc'), C ? $f91994d6acc8623b$var$E(n.he, 'aria-label', C) : w && $f91994d6acc8623b$var$E(n.he, 'aria-labelledby', 'cm__title');
        const e = 'box', t = o.i.guiOptions, a = t && t.consentModal, s = (a && a.layout || e).split(' ')[0] === e;
        w && y && s && (n.Le || (n.Le = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$r), n.Le.innerHTML = $f91994d6acc8623b$var$W(), $f91994d6acc8623b$var$I(n.Le, 'btn'), $f91994d6acc8623b$var$I(n.Le, 'btn--close'), $f91994d6acc8623b$var$R(n.Le, $f91994d6acc8623b$var$d, ()=>{
            S([]);
        }), $f91994d6acc8623b$var$H(n.We, n.Le)), $f91994d6acc8623b$var$E(n.Le, 'aria-label', y)), $f91994d6acc8623b$var$H(n.We, n.Xe), (m || b || v) && $f91994d6acc8623b$var$H(n.We, n.Ye), n.be = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$c), $f91994d6acc8623b$var$E(n.be, 'tabIndex', -1), $f91994d6acc8623b$var$H(n.he, n.be), $f91994d6acc8623b$var$H(n.he, n.We), $f91994d6acc8623b$var$H(n.Qe, n.he);
    }
    w && (n.Ze || (n.Ze = $f91994d6acc8623b$var$k('h2'), n.Ze.className = n.Ze.id = 'cm__title', $f91994d6acc8623b$var$H(n.Xe, n.Ze)), n.Ze.innerHTML = w);
    let x = p.description;
    if (x && (o.V && (x = x.replace('{{revisionMessage}}', o.I ? '' : p.revisionMessage || '')), n.et || (n.et = $f91994d6acc8623b$var$k('p'), n.et.className = n.et.id = 'cm__desc', $f91994d6acc8623b$var$H(n.Xe, n.et)), n.et.innerHTML = x), m && (n.tt || (n.tt = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$r), $f91994d6acc8623b$var$H(n.tt, $f91994d6acc8623b$var$ve()), $f91994d6acc8623b$var$I(n.tt, 'btn'), $f91994d6acc8623b$var$E(n.tt, $f91994d6acc8623b$var$f, 'all'), $f91994d6acc8623b$var$R(n.tt, $f91994d6acc8623b$var$d, ()=>{
        S('all');
    })), n.tt.firstElementChild.innerHTML = m), b && (n.Ie || (n.Ie = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$r), $f91994d6acc8623b$var$H(n.Ie, $f91994d6acc8623b$var$ve()), $f91994d6acc8623b$var$I(n.Ie, 'btn'), $f91994d6acc8623b$var$E(n.Ie, $f91994d6acc8623b$var$f, 'necessary'), $f91994d6acc8623b$var$R(n.Ie, $f91994d6acc8623b$var$d, ()=>{
        S([]);
    })), n.Ie.firstElementChild.innerHTML = b), v && (n.ot || (n.ot = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$r), $f91994d6acc8623b$var$H(n.ot, $f91994d6acc8623b$var$ve()), $f91994d6acc8623b$var$I(n.ot, 'btn'), $f91994d6acc8623b$var$I(n.ot, 'btn--secondary'), $f91994d6acc8623b$var$E(n.ot, $f91994d6acc8623b$var$f, 'show'), $f91994d6acc8623b$var$R(n.ot, 'mouseenter', ()=>{
        o.N || $f91994d6acc8623b$var$me(e, t);
    }), $f91994d6acc8623b$var$R(n.ot, $f91994d6acc8623b$var$d, s)), n.ot.firstElementChild.innerHTML = v), n.nt || (n.nt = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$c), $f91994d6acc8623b$var$I(n.nt, $f91994d6acc8623b$var$l), m && $f91994d6acc8623b$var$H(n.nt, n.tt), b && $f91994d6acc8623b$var$H(n.nt, n.Ie), (m || b) && $f91994d6acc8623b$var$H(n.We, n.nt), $f91994d6acc8623b$var$H(n.Ye, n.nt)), n.ot && !n.st && (n.st = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$c), n.Ie && n.tt ? ($f91994d6acc8623b$var$I(n.st, $f91994d6acc8623b$var$l), $f91994d6acc8623b$var$H(n.st, n.ot), $f91994d6acc8623b$var$H(n.Ye, n.st)) : ($f91994d6acc8623b$var$H(n.nt, n.ot), $f91994d6acc8623b$var$I(n.nt, $f91994d6acc8623b$var$l + '--uneven'))), h) {
        if (!n.ct) {
            let e = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$c), t = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$c);
            n.ct = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$c), $f91994d6acc8623b$var$I(e, 'footer'), $f91994d6acc8623b$var$I(t, 'links'), $f91994d6acc8623b$var$I(n.ct, 'link-group'), $f91994d6acc8623b$var$H(t, n.ct), $f91994d6acc8623b$var$H(e, t), $f91994d6acc8623b$var$H(n.he, e);
        }
        n.ct.innerHTML = h;
    }
    $f91994d6acc8623b$var$pe(0), o.T || (o.T = !0, $f91994d6acc8623b$var$ee($f91994d6acc8623b$var$g.re.ue, $f91994d6acc8623b$var$_, n.he), t(e), $f91994d6acc8623b$var$H(n.Ce, n.Qe), $f91994d6acc8623b$var$X(n.he), setTimeout(()=>$f91994d6acc8623b$var$V(n.Qe, 'cc--anim'), 100)), $f91994d6acc8623b$var$Z(1), $f91994d6acc8623b$var$J(n.We, e, $f91994d6acc8623b$var$me, t);
}, $f91994d6acc8623b$var$he = (e)=>{
    if (!$f91994d6acc8623b$var$y(e)) return null;
    if (e in $f91994d6acc8623b$var$g.o._) return e;
    let t = e.slice(0, 2);
    return t in $f91994d6acc8623b$var$g.o._ ? t : null;
}, $f91994d6acc8623b$var$Ce = ()=>$f91994d6acc8623b$var$g.o.l || $f91994d6acc8623b$var$g.o.i.language.default, $f91994d6acc8623b$var$we = (e)=>{
    e && ($f91994d6acc8623b$var$g.o.l = e);
}, $f91994d6acc8623b$var$Se = async (e)=>{
    const t = $f91994d6acc8623b$var$g.o;
    let o = $f91994d6acc8623b$var$he(e) ? e : $f91994d6acc8623b$var$Ce(), n = t._[o];
    if ($f91994d6acc8623b$var$y(n) ? n = await (async (e)=>{
        try {
            const t = await fetch(e);
            return await t.json();
        } catch (e) {
            return console.error(e), !1;
        }
    })(n) : $f91994d6acc8623b$var$C(n) && (n = await n()), !n) throw `Could not load translation for the '${o}' language`;
    return t.u = n, $f91994d6acc8623b$var$we(o), !0;
}, $f91994d6acc8623b$var$xe = ()=>{
    let e = $f91994d6acc8623b$var$g.o.i.language.rtl, t = $f91994d6acc8623b$var$g.ne.Ce;
    e && t && ($f91994d6acc8623b$var$v(e) || (e = [
        e
    ]), $f91994d6acc8623b$var$b(e, $f91994d6acc8623b$var$g.o.l) ? $f91994d6acc8623b$var$V(t, 'cc--rtl') : $f91994d6acc8623b$var$j(t, 'cc--rtl'));
}, $f91994d6acc8623b$var$Me = ()=>{
    const e = $f91994d6acc8623b$var$g.ne;
    if (e.Ce) return;
    e.Ce = $f91994d6acc8623b$var$k($f91994d6acc8623b$var$c), e.Ce.id = 'cc-main', e.Ce.setAttribute('data-nosnippet', ''), $f91994d6acc8623b$var$xe();
    let t = $f91994d6acc8623b$var$g.o.i.root;
    t && $f91994d6acc8623b$var$y(t) && (t = document.querySelector(t)), (t || e.Ue.body).appendChild(e.Ce);
}, $f91994d6acc8623b$var$De = (e)=>$f91994d6acc8623b$var$te(()=>localStorage.removeItem(e)), $f91994d6acc8623b$var$Te = (e, t)=>{
    if (t instanceof RegExp) return e.filter((e)=>t.test(e));
    {
        const o = $f91994d6acc8623b$var$m(e, t);
        return o > -1 ? [
            e[o]
        ] : [];
    }
}, $f91994d6acc8623b$var$ke = (e)=>{
    const { hostname: t, protocol: o } = location, { name: n, path: a, domain: s, sameSite: c, useLocalStorage: r, secure: i } = $f91994d6acc8623b$var$g.t.cookie, l = e ? (()=>{
        const e = $f91994d6acc8623b$var$g.o.S, t = e ? new Date - e : 0;
        return 864e5 * $f91994d6acc8623b$var$B() - t;
    })() : 864e5 * $f91994d6acc8623b$var$B(), d = new Date;
    d.setTime(d.getTime() + l), $f91994d6acc8623b$var$g.o.p.expirationTime = d.getTime();
    const f = JSON.stringify($f91994d6acc8623b$var$g.o.p);
    let _ = n + '=' + encodeURIComponent(f) + (0 !== l ? '; expires=' + d.toUTCString() : '') + '; Path=' + a + '; SameSite=' + c;
    $f91994d6acc8623b$var$b(t, '.') && (_ += '; Domain=' + s), i && 'https:' === o && (_ += '; Secure'), r ? ((e, t)=>{
        $f91994d6acc8623b$var$te(()=>localStorage.setItem(e, t));
    })(n, f) : document.cookie = _, $f91994d6acc8623b$var$g.o.p;
}, $f91994d6acc8623b$var$Ee = (e, t, o)=>{
    if (0 === e.length) return;
    const n = o || $f91994d6acc8623b$var$g.t.cookie.domain, a = t || $f91994d6acc8623b$var$g.t.cookie.path, s = 'www.' === n.slice(0, 4), c = s && n.substring(4), r = (e, t)=>{
        t && '.' !== t.slice(0, 1) && (t = '.' + t), document.cookie = e + '=; path=' + a + (t ? '; domain=' + t : '') + '; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    };
    for (const t of e)r(t, o), o || r(t, n), s && r(t, c);
}, $f91994d6acc8623b$var$Ae = (e)=>{
    const t = e || $f91994d6acc8623b$var$g.t.cookie.name, o = $f91994d6acc8623b$var$g.t.cookie.useLocalStorage;
    var n;
    return ((e, t)=>{
        let o;
        return o = $f91994d6acc8623b$var$te(()=>JSON.parse(t ? e : decodeURIComponent(e)), !0) || {}, o;
    })(o ? (n = t, $f91994d6acc8623b$var$te(()=>localStorage.getItem(n)) || '') : $f91994d6acc8623b$var$Ne(t, !0), o);
}, $f91994d6acc8623b$var$Ne = (e, t)=>{
    const o = document.cookie.match('(^|;)\\s*' + e + '\\s*=\\s*([^;]+)');
    return o ? t ? o.pop() : e : '';
}, $f91994d6acc8623b$var$He = (e)=>{
    const t = document.cookie.split(/;\s*/), o = [];
    for (const n of t){
        let t = n.split('=')[0];
        e ? $f91994d6acc8623b$var$te(()=>{
            e.test(t) && o.push(t);
        }) : o.push(t);
    }
    return o;
}, $f91994d6acc8623b$export$f733614a75aede52 = (o, n = [])=>{
    ((e, t)=>{
        const { O: o, R: n, B: a, N: s, Z: c, $: r, X: i } = $f91994d6acc8623b$var$g.o;
        let l = [];
        if (e) {
            $f91994d6acc8623b$var$v(e) ? l.push(...e) : $f91994d6acc8623b$var$y(e) && (l = 'all' === e ? o : [
                e
            ]);
            for (const e of o)c[e] = $f91994d6acc8623b$var$b(l, e) ? $f91994d6acc8623b$var$w(i[e]) : [];
        } else l = [
            ...n,
            ...r
        ], s && (l = (()=>{
            const e = $f91994d6acc8623b$var$g.ne.ae;
            if (!e) return [];
            let t = [];
            for(let o in e)e[o].checked && t.push(o);
            return t;
        })());
        l = l.filter((e)=>!$f91994d6acc8623b$var$b(o, e) || !$f91994d6acc8623b$var$b(t, e)), l.push(...a), $f91994d6acc8623b$var$G(l);
    })(o, n), (()=>{
        const e = $f91994d6acc8623b$var$g.o, { Z: t, B: o, Y: n, X: a, O: s } = e, c = s;
        e.te = $f91994d6acc8623b$var$F(n);
        for (const s of c){
            const c = a[s], r = $f91994d6acc8623b$var$w(c), i = t[s] && t[s].length > 0, l = $f91994d6acc8623b$var$b(o, s);
            if (0 !== r.length) {
                if (n[s] = [], l) n[s].push(...r);
                else if (i) {
                    const e = t[s];
                    n[s].push(...e);
                } else n[s] = e.Z[s];
                n[s] = $f91994d6acc8623b$var$S(n[s]);
            }
        }
    })(), (()=>{
        const o = $f91994d6acc8623b$var$g.o;
        o.L = $f91994d6acc8623b$var$g.t.mode === $f91994d6acc8623b$var$t && o.D ? $f91994d6acc8623b$var$$(o.$, o.R) : $f91994d6acc8623b$var$$(o.R, o.p.categories);
        let n = o.L.length > 0, a = !1;
        for (const e of o.O)o.ee[e] = $f91994d6acc8623b$var$$(o.Y[e], o.te[e]), o.ee[e].length > 0 && (a = !0);
        const s = $f91994d6acc8623b$var$g.ne.ae;
        for(const e in s)s[e].checked = $f91994d6acc8623b$var$b(o.R, e);
        for (const e of o.O){
            const t = $f91994d6acc8623b$var$g.ne.se[e], n = o.Y[e];
            for(const e in t)t[e].checked = $f91994d6acc8623b$var$b(n, e);
        }
        o.C || (o.C = new Date), o.M || (o.M = "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (e)=>(e ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> e / 4).toString(16))), o.p = {
            categories: $f91994d6acc8623b$var$F(o.R),
            revision: $f91994d6acc8623b$var$g.t.revision,
            data: o.h,
            consentTimestamp: o.C.toISOString(),
            consentId: o.M,
            services: $f91994d6acc8623b$var$F(o.Y),
            languageCode: $f91994d6acc8623b$var$g.o.l
        }, o.S && (o.p.lastConsentTimestamp = o.S.toISOString());
        let c = !1;
        const r = n || a;
        (o.D || r) && (o.D && (o.D = !1, c = !0), o.S = o.S ? new Date : o.C, o.p.lastConsentTimestamp = o.S.toISOString(), $f91994d6acc8623b$var$ke(), $f91994d6acc8623b$var$g.t.autoClearCookies && (c || r) && ((e)=>{
            const t = $f91994d6acc8623b$var$g.o, o = $f91994d6acc8623b$var$He(), n = ((e)=>{
                const t = $f91994d6acc8623b$var$g.o;
                return (e ? t.O : t.L).filter((e)=>{
                    const o = t.P[e];
                    return !!o && !o.readOnly && !!o.autoClear;
                });
            })(e);
            for(const e in t.ee)for (const n of t.ee[e]){
                const a = t.X[e][n].cookies;
                if (!$f91994d6acc8623b$var$b(t.Y[e], n) && a) for (const e of a){
                    const t = $f91994d6acc8623b$var$Te(o, e.name);
                    $f91994d6acc8623b$var$Ee(t, e.path, e.domain);
                }
            }
            for (const a of n){
                const n = t.P[a].autoClear, s = n && n.cookies || [], c = $f91994d6acc8623b$var$b(t.L, a), r = !$f91994d6acc8623b$var$b(t.R, a), i = c && r;
                if (e ? r : i) {
                    n.reloadPage && i && (t.j = !0);
                    for (const e of s){
                        const t = $f91994d6acc8623b$var$Te(o, e.name);
                        $f91994d6acc8623b$var$Ee(t, e.path, e.domain);
                    }
                }
            }
        })(c), $f91994d6acc8623b$var$oe()), c && ($f91994d6acc8623b$var$ee($f91994d6acc8623b$var$g.re.ie), $f91994d6acc8623b$var$ee($f91994d6acc8623b$var$g.re.le), $f91994d6acc8623b$var$g.t.mode === $f91994d6acc8623b$var$e) || (r && $f91994d6acc8623b$var$ee($f91994d6acc8623b$var$g.re.de), o.j && (o.j = !1, location.reload()));
    })();
}, $f91994d6acc8623b$export$d57953daf19d40f0 = (e)=>{
    const t = $f91994d6acc8623b$var$g.o.D ? [] : $f91994d6acc8623b$var$g.o.R;
    return $f91994d6acc8623b$var$b(t, e);
}, $f91994d6acc8623b$export$954bc960519baaed = (e, t)=>{
    const { O: o, X: n } = $f91994d6acc8623b$var$g.o;
    if (!(e && t && $f91994d6acc8623b$var$y(t) && $f91994d6acc8623b$var$b(o, t) && 0 !== $f91994d6acc8623b$var$w(n[t]).length)) return !1;
    ((e, t)=>{
        const o = $f91994d6acc8623b$var$g.o, { X: n, Z: a, N: s } = o, c = $f91994d6acc8623b$var$g.ne.se[t] || {}, r = $f91994d6acc8623b$var$g.ne.ae[t] || {}, i = $f91994d6acc8623b$var$w(n[t]);
        if (a[t] = [], $f91994d6acc8623b$var$y(e)) {
            if ('all' === e) {
                if (a[t].push(...i), s) for(let e in c)c[e].checked = !0, $f91994d6acc8623b$var$T(c[e]);
            } else if ($f91994d6acc8623b$var$b(i, e) && a[t].push(e), s) for(let t in c)c[t].checked = e === t, $f91994d6acc8623b$var$T(c[t]);
        } else if ($f91994d6acc8623b$var$v(e)) for (let o of i){
            const n = $f91994d6acc8623b$var$b(e, o);
            n && a[t].push(o), s && (c[o].checked = n, $f91994d6acc8623b$var$T(c[o]));
        }
        const l = 0 === a[t].length;
        o.R = l ? o.R.filter((e)=>e !== t) : $f91994d6acc8623b$var$S([
            ...o.R,
            t
        ]), s && (r.checked = !l, $f91994d6acc8623b$var$T(r));
    })(e, t), $f91994d6acc8623b$export$f733614a75aede52();
}, $f91994d6acc8623b$export$c6d040ca60661d88 = (e, t)=>{
    const o = $f91994d6acc8623b$var$g.o.D ? [] : $f91994d6acc8623b$var$g.o.Y[t] || [];
    return $f91994d6acc8623b$var$b(o, e);
}, $f91994d6acc8623b$export$26b2c20fc8da53a0 = (e)=>'' !== $f91994d6acc8623b$var$Ne(e, !0), $f91994d6acc8623b$export$6dde6a4e31d2b3a6 = (e, t, o)=>{
    let n = [];
    const a = (e)=>{
        if ($f91994d6acc8623b$var$y(e)) {
            let t = $f91994d6acc8623b$var$Ne(e);
            '' !== t && n.push(t);
        } else n.push(...$f91994d6acc8623b$var$He(e));
    };
    if ($f91994d6acc8623b$var$v(e)) for (let t of e)a(t);
    else a(e);
    $f91994d6acc8623b$var$Ee(n, t, o);
}, $f91994d6acc8623b$export$57bf213be019eeb0 = (e)=>{
    const { ne: t, o: n } = $f91994d6acc8623b$var$g;
    if (!n.k) {
        if (!n.T) {
            if (!e) return;
            $f91994d6acc8623b$var$ye($f91994d6acc8623b$var$Ge, $f91994d6acc8623b$var$Me);
        }
        n.k = !0, n.J = $f91994d6acc8623b$var$x(), n.v && $f91994d6acc8623b$var$K(!0), $f91994d6acc8623b$var$z(t.he, 1), $f91994d6acc8623b$var$V(t.ye, $f91994d6acc8623b$var$o), $f91994d6acc8623b$var$E(t.he, $f91994d6acc8623b$var$i, 'false'), setTimeout(()=>{
            $f91994d6acc8623b$var$U($f91994d6acc8623b$var$g.ne.be);
        }, 100), $f91994d6acc8623b$var$ee($f91994d6acc8623b$var$g.re.fe, $f91994d6acc8623b$var$_);
    }
}, $f91994d6acc8623b$export$fe8985bb6374093c = ()=>{
    const { ne: e, o: t, re: n } = $f91994d6acc8623b$var$g;
    t.k && (t.k = !1, t.v && $f91994d6acc8623b$var$K(), $f91994d6acc8623b$var$U(e.Ke, !0), $f91994d6acc8623b$var$j(e.ye, $f91994d6acc8623b$var$o), $f91994d6acc8623b$var$E(e.he, $f91994d6acc8623b$var$i, 'true'), $f91994d6acc8623b$var$U(t.J), t.J = null, $f91994d6acc8623b$var$ee(n._e, $f91994d6acc8623b$var$_));
}, $f91994d6acc8623b$export$535e69674d40eb20 = ()=>{
    const e = $f91994d6acc8623b$var$g.o;
    e.A || (e.N || $f91994d6acc8623b$var$me($f91994d6acc8623b$var$Ge, $f91994d6acc8623b$var$Me), e.A = !0, e.k ? e.U = $f91994d6acc8623b$var$x() : e.J = $f91994d6acc8623b$var$x(), $f91994d6acc8623b$var$z($f91994d6acc8623b$var$g.ne.we, 2), $f91994d6acc8623b$var$V($f91994d6acc8623b$var$g.ne.ye, $f91994d6acc8623b$var$n), $f91994d6acc8623b$var$E($f91994d6acc8623b$var$g.ne.we, $f91994d6acc8623b$var$i, 'false'), setTimeout(()=>{
        $f91994d6acc8623b$var$U($f91994d6acc8623b$var$g.ne.ve);
    }, 100), $f91994d6acc8623b$var$ee($f91994d6acc8623b$var$g.re.fe, $f91994d6acc8623b$var$u));
}, $f91994d6acc8623b$export$5b3a895f6cbac580 = ()=>{
    const e = $f91994d6acc8623b$var$g.o;
    e.A && (e.A = !1, (()=>{
        const e = $f91994d6acc8623b$export$3bdcc4c9b3764a39(), t = $f91994d6acc8623b$var$g.o.P, o = $f91994d6acc8623b$var$g.ne.ae, n = $f91994d6acc8623b$var$g.ne.se, a = (e)=>$f91994d6acc8623b$var$b($f91994d6acc8623b$var$g.o.$, e);
        for(const s in o){
            const c = !!t[s].readOnly;
            o[s].checked = c || (e ? $f91994d6acc8623b$export$d57953daf19d40f0(s) : a(s));
            for(const t in n[s])n[s][t].checked = c || (e ? $f91994d6acc8623b$export$c6d040ca60661d88(t, s) : a(s));
        }
    })(), $f91994d6acc8623b$var$U($f91994d6acc8623b$var$g.ne.$e, !0), $f91994d6acc8623b$var$j($f91994d6acc8623b$var$g.ne.ye, $f91994d6acc8623b$var$n), $f91994d6acc8623b$var$E($f91994d6acc8623b$var$g.ne.we, $f91994d6acc8623b$var$i, 'true'), e.k ? ($f91994d6acc8623b$var$U(e.U), e.U = null) : ($f91994d6acc8623b$var$U(e.J), e.J = null), $f91994d6acc8623b$var$ee($f91994d6acc8623b$var$g.re._e, $f91994d6acc8623b$var$u));
};
var $f91994d6acc8623b$var$Ge = {
    show: $f91994d6acc8623b$export$57bf213be019eeb0,
    hide: $f91994d6acc8623b$export$fe8985bb6374093c,
    showPreferences: $f91994d6acc8623b$export$535e69674d40eb20,
    hidePreferences: $f91994d6acc8623b$export$5b3a895f6cbac580,
    acceptCategory: $f91994d6acc8623b$export$f733614a75aede52
};
const $f91994d6acc8623b$export$4b6bf64406ec64af = async (e, t)=>{
    if (!$f91994d6acc8623b$var$he(e)) return !1;
    const o = $f91994d6acc8623b$var$g.o;
    return !(e === $f91994d6acc8623b$var$Ce() && !0 !== t || !await $f91994d6acc8623b$var$Se(e) || ($f91994d6acc8623b$var$we(e), o.T && $f91994d6acc8623b$var$ye($f91994d6acc8623b$var$Ge, $f91994d6acc8623b$var$Me), o.N && $f91994d6acc8623b$var$me($f91994d6acc8623b$var$Ge, $f91994d6acc8623b$var$Me), $f91994d6acc8623b$var$xe(), 0));
}, $f91994d6acc8623b$export$ae3f5fa351e2f57a = ()=>{
    const { F: e, Y: t } = $f91994d6acc8623b$var$g.o, { accepted: o, rejected: n } = (()=>{
        const { D: e, R: t, O: o } = $f91994d6acc8623b$var$g.o;
        return {
            accepted: t,
            rejected: e ? [] : o.filter((e)=>!$f91994d6acc8623b$var$b(t, e))
        };
    })();
    return $f91994d6acc8623b$var$F({
        acceptType: e,
        acceptedCategories: o,
        rejectedCategories: n,
        acceptedServices: t,
        rejectedServices: $f91994d6acc8623b$var$P()
    });
}, $f91994d6acc8623b$export$2cb99e4be0dc4646 = (e, t)=>{
    let o = document.querySelector('script[src="' + e + '"]');
    return new Promise((n)=>{
        if (o) return n(!0);
        if (o = $f91994d6acc8623b$var$k('script'), $f91994d6acc8623b$var$h(t)) for(const e in t)$f91994d6acc8623b$var$E(o, e, t[e]);
        o.onload = ()=>n(!0), o.onerror = ()=>{
            o.remove(), n(!1);
        }, o.src = e, $f91994d6acc8623b$var$H(document.head, o);
    });
}, $f91994d6acc8623b$export$3cbc67a40c3171bd = (e)=>{
    let t, o = e.value, n = e.mode, a = !1;
    const s = $f91994d6acc8623b$var$g.o;
    if ('update' === n) {
        s.h = t = $f91994d6acc8623b$export$4be65e66cfa2648a('data');
        const e = typeof t == typeof o;
        if (e && 'object' == typeof t) {
            !t && (t = {});
            for(let e in o)t[e] !== o[e] && (t[e] = o[e], a = !0);
        } else !e && t || t === o || (t = o, a = !0);
    } else t = o, a = !0;
    return a && (s.h = t, s.p.data = t, $f91994d6acc8623b$var$ke(!0)), a;
}, $f91994d6acc8623b$export$4be65e66cfa2648a = (e, t)=>{
    const o = $f91994d6acc8623b$var$Ae(t);
    return e ? o[e] : o;
}, $f91994d6acc8623b$export$44487a86467333c3 = (e)=>{
    const t = $f91994d6acc8623b$var$g.t, o = $f91994d6acc8623b$var$g.o.i;
    return e ? t[e] || o[e] : {
        ...t,
        ...o,
        cookie: {
            ...t.cookie
        }
    };
}, $f91994d6acc8623b$export$3bdcc4c9b3764a39 = ()=>!$f91994d6acc8623b$var$g.o.D, $f91994d6acc8623b$export$889ea624f2cb2c57 = async (e)=>{
    const { o: o, t: n, re: a } = $f91994d6acc8623b$var$g, c = window;
    if (!c._ccRun) {
        if (c._ccRun = !0, ((e)=>{
            const { ne: o, t: n, o: a } = $f91994d6acc8623b$var$g, c = n, r = a, { cookie: i } = c, l = $f91994d6acc8623b$var$g.ce, d = e.cookie, f = e.categories, _ = $f91994d6acc8623b$var$w(f) || [], u = navigator, p = document;
            o.Ue = p, o.ye = p.documentElement, i.domain = location.hostname, r.i = e, r.P = f, r.O = _, r._ = e.language.translations, r.v = !!e.disablePageInteraction, l.ie = e.onFirstConsent, l.le = e.onConsent, l.de = e.onChange, l._e = e.onModalHide, l.fe = e.onModalShow, l.ue = e.onModalReady;
            const { mode: m, autoShow: v, lazyHtmlGeneration: y, autoClearCookies: C, revision: S, manageScriptTags: x, hideFromBots: M } = e;
            m === $f91994d6acc8623b$var$t && (c.mode = m), 'boolean' == typeof C && (c.autoClearCookies = C), 'boolean' == typeof x && (c.manageScriptTags = x), 'number' == typeof S && S >= 0 && (c.revision = S, r.V = !0), 'boolean' == typeof v && (c.autoShow = v), 'boolean' == typeof y && (c.lazyHtmlGeneration = y), !1 === M && (c.hideFromBots = !1), !0 === c.hideFromBots && u && (r.G = u.userAgent && /bot|crawl|spider|slurp|teoma/i.test(u.userAgent) || u.webdriver), $f91994d6acc8623b$var$h(d) && (c.cookie = {
                ...i,
                ...d
            }), c.autoClearCookies, r.V, c.manageScriptTags, ((e)=>{
                const { P: t, X: o, Y: n, Z: a, B: s } = $f91994d6acc8623b$var$g.o;
                for (let c of e){
                    const e = t[c], r = e.services || {}, i = $f91994d6acc8623b$var$h(r) && $f91994d6acc8623b$var$w(r) || [];
                    o[c] = {}, n[c] = [], a[c] = [], e.readOnly && (s.push(c), n[c] = i), $f91994d6acc8623b$var$g.ne.se[c] = {};
                    for (let e of i){
                        const t = r[e];
                        t.Se = !1, o[c][e] = t;
                    }
                }
            })(_), (()=>{
                if (!$f91994d6acc8623b$var$g.t.manageScriptTags) return;
                const e = $f91994d6acc8623b$var$g.o, t = $f91994d6acc8623b$var$D(document, 'script[' + $f91994d6acc8623b$var$s + ']');
                for (const o of t){
                    let t = $f91994d6acc8623b$var$N(o, $f91994d6acc8623b$var$s), n = o.dataset.service || '', a = !1;
                    if (t && '!' === t.charAt(0) && (t = t.slice(1), a = !0), '!' === n.charAt(0) && (n = n.slice(1), a = !0), $f91994d6acc8623b$var$b(e.O, t) && (e.oe.push({
                        Me: o,
                        xe: !1,
                        ke: a,
                        De: t,
                        Te: n
                    }), n)) {
                        const o = e.X[t];
                        o[n] || (o[n] = {
                            Se: !1
                        });
                    }
                }
            })(), $f91994d6acc8623b$var$we((()=>{
                const e = $f91994d6acc8623b$var$g.o.i.language.autoDetect;
                if (e) {
                    const t = {
                        browser: navigator.language,
                        document: document.documentElement.lang
                    }, o = $f91994d6acc8623b$var$he(t[e]);
                    if (o) return o;
                }
                return $f91994d6acc8623b$var$Ce();
            })());
        })(e), o.G) return;
        (()=>{
            const e = $f91994d6acc8623b$var$g.o, o = $f91994d6acc8623b$var$g.t, n = $f91994d6acc8623b$var$Ae(), { categories: a, services: s, consentId: c, consentTimestamp: r, lastConsentTimestamp: i, data: l, revision: d } = n, f = $f91994d6acc8623b$var$v(a);
            e.p = n, e.M = c;
            const _ = !!c && $f91994d6acc8623b$var$y(c);
            e.C = r, e.C && (e.C = new Date(r)), e.S = i, e.S && (e.S = new Date(i)), e.h = void 0 !== l ? l : null, e.V && _ && d !== o.revision && (e.I = !1), e.D = !(_ && e.I && e.C && e.S && f), o.cookie.useLocalStorage && !e.D && (e.D = (new Date).getTime() > (n.expirationTime || 0), e.D && $f91994d6acc8623b$var$De(o.cookie.name)), e.D, (()=>{
                const e = $f91994d6acc8623b$var$g.o;
                for (const o of e.O){
                    const n = e.P[o];
                    if (n.readOnly || n.enabled) {
                        e.$.push(o);
                        const n = e.X[o] || {};
                        for(let a in n)e.Z[o].push(a), e.i.mode === $f91994d6acc8623b$var$t && e.Y[o].push(a);
                    }
                }
            })(), e.D ? o.mode === $f91994d6acc8623b$var$t && (e.R = [
                ...e.$
            ]) : (e.Y = {
                ...e.Y,
                ...s
            }, e.Z = {
                ...e.Y
            }, $f91994d6acc8623b$var$G([
                ...e.B,
                ...a
            ]));
        })();
        const i = $f91994d6acc8623b$export$3bdcc4c9b3764a39();
        if (!await $f91994d6acc8623b$var$Se()) return !1;
        if ($f91994d6acc8623b$var$J(null, r = $f91994d6acc8623b$var$Ge, $f91994d6acc8623b$var$me, $f91994d6acc8623b$var$Me), $f91994d6acc8623b$var$g.o.D && $f91994d6acc8623b$var$ye(r, $f91994d6acc8623b$var$Me), $f91994d6acc8623b$var$g.t.lazyHtmlGeneration || $f91994d6acc8623b$var$me(r, $f91994d6acc8623b$var$Me), n.autoShow && !i && $f91994d6acc8623b$export$57bf213be019eeb0(!0), i) return $f91994d6acc8623b$var$oe(), $f91994d6acc8623b$var$ee(a.le);
        n.mode === $f91994d6acc8623b$var$t && $f91994d6acc8623b$var$oe(o.$);
    }
    var r;
}, $f91994d6acc8623b$export$aad8462122ac592b = (e)=>{
    const { Ce: t, ye: s } = $f91994d6acc8623b$var$g.ne, { name: c, path: r, domain: i, useLocalStorage: l } = $f91994d6acc8623b$var$g.t.cookie;
    e && (l ? $f91994d6acc8623b$var$De(c) : $f91994d6acc8623b$export$6dde6a4e31d2b3a6(c, r, i));
    for (const { pe: e, ge: t, me: o } of $f91994d6acc8623b$var$g.o.m)e.removeEventListener(t, o);
    t && t.remove(), s && s.classList.remove($f91994d6acc8623b$var$a, $f91994d6acc8623b$var$n, $f91994d6acc8623b$var$o);
    const d = new $f91994d6acc8623b$var$p;
    for(const e in $f91994d6acc8623b$var$g)$f91994d6acc8623b$var$g[e] = d[e];
    window._ccRun = !1;
};


// Ajouter un service dans le markup HTML:
// <script type="textplain" data-category="analytics" data-service="ga">Code GA ici</script>
// NOTE: textplain au lieu de text/plain: ça fonctionne idem et évite l'erreur parcel qui ne doit pas apprécier le "/"
// Enable dark mode
//document.documentElement.classList.add('cc--darkmode');
(0, $f91994d6acc8623b$export$889ea624f2cb2c57)({
    cookie: {
        useLocalStorage: true // Juste pour éviter des collisions entre vitroto.fr et {dev,test}.vitroto.fr
    },
    guiOptions: {
        consentModal: {
            layout: "box inline",
            position: "bottom left",
            equalWeightButtons: true,
            flipButtons: false
        },
        preferencesModal: {
            layout: "box",
            position: "right",
            equalWeightButtons: true,
            flipButtons: false
        }
    },
    categories: {
        necessary: {
            // Défaut: enabled false, readonly false
            readOnly: true
        }
    },
    language: {
        default: "fr",
        translations: {
            fr: {
                consentModal: {
                    title: "\uD83C\uDF6A Nous utilisons des cookies !",
                    description: "Nous utilisons des cookies pour am\xe9liorer votre exp\xe9rience sur notre site, mesurer l\u2019audience et vous proposer des contenus adapt\xe9s \xe0 vos pr\xe9f\xe9rences. En cliquant sur \xab Accepter \xbb, vous consentez \xe0 leur utilisation.",
                    acceptAllBtn: "Tout accepter",
                    acceptNecessaryBtn: "Tout rejeter",
                    showPreferencesBtn: "G\xe9rer les pr\xe9f\xe9rences",
                    footer: '<a href="/politique-de-confidentialite">Politique de confidentialit\xe9</a>\n<a href="/cgv">Termes et conditions</a>'
                },
                preferencesModal: {
                    title: "Pr\xe9f\xe9rences des cookies",
                    acceptAllBtn: "Tout accepter",
                    acceptNecessaryBtn: "Tout rejeter",
                    savePreferencesBtn: "Sauvegarder les pr\xe9f\xe9rences",
                    closeIconLabel: "Fermer la modale",
                    serviceCounterLabel: "Services",
                    sections: [
                        {
                            title: "Personnalisez vos pr\xe9f\xe9rences de cookies \uD83C\uDF6A",
                            description: "Vous pouvez choisir les cat\xe9gories de cookies que vous souhaitez autoriser ou refuser. Les cookies n\xe9cessaires assurent le fonctionnement du site et ne peuvent pas \xeatre d\xe9sactiv\xe9s. S\xe9lectionnez ci-dessous vos pr\xe9f\xe9rences puis cliquez sur \xab Sauvegarder les pr\xe9f\xe9rences \xbb."
                        },
                        {
                            title: 'Cookies Strictement N\xe9cessaires <span class="pm__badge">Toujours Activ\xe9</span>',
                            description: "Ce site utilise un cookie de session, un cookie pour se rappeler de vous et enregistre les presents choix en mati\xe8re de cookies dans le localStorage, aucune de ces informations n'est identifiante.",
                            linkedCategory: "necessary"
                        },
                        /*
                        {
                            title: "Cookies Analytiques",
                            description: "Ces cookies permettent d'analyser le comportement général des utilisateurs du site.",
                            linkedCategory: "analytics",
			    cookieTable: {
                                headers: {
                                    name: "Nom",
                                    domain: "Service",
                                    description: "Description",
                                    expiration: "Expiration"
                                },
                                body: [
                                    {
                                        name: "_ga",
                                        domain: "Google Analytics",
                                        description: "Cookie mis en place par <a href=\"#das\">Google Analytics</a>",
                                        expiration: "Expire après 12 jours"
                                    },
                                    {
                                        name: "_gid",
                                        domain: "Google Analytics",
                                        description: "Cookie mis en place par <a href=\"#das\">Google Analytics</a>",
                                        expiration: "Session"
                                    }
                                ]
                            }
                        },
			*/ {
                            title: "Plus d'informations",
                            // Todo: quand la page contact sera implémentée, ajouter le lien, ex:
                            //<a class=\"cc__link\" href=\"/contact\">contact me</a>
                            description: "Pour toute demande en relation avec la politique cookies et vos choix, veuillez nous contacter via le formulaire de contact."
                        }
                    ]
                }
            }
        }
    }
});

})();
//# sourceMappingURL=404.b4314288.js.map
